// „Nächster Lead“-Fluss: die zuletzt geöffnete Liste (Smart View, Leads, Inbox) merken, damit die Lead-Seite
// vor/zurück und „zurück zur Liste“ anbieten kann. Je Browser-Tab (sessionStorage).
import { useEffect, useState } from "react";

export interface ListenKontext {
  quelle: "smartview" | "leads" | "inbox";
  titel: string;
  /** Pfad der Liste inkl. Suche, z. B. /smart-views/save_… */
  pfad: string;
  ids: string[];
  /** zuletzt geöffneter Lead (für die Markierung beim Zurückkehren) */
  fokus?: string | null;
}

const SCHLUESSEL = "crm-liste";
const EREIGNIS = "crm:liste";
let speicher: ListenKontext | null = null;

export function listeLesen(): ListenKontext | null {
  if (speicher) return speicher;
  try {
    const roh = sessionStorage.getItem(SCHLUESSEL);
    speicher = roh ? (JSON.parse(roh) as ListenKontext) : null;
  } catch {
    speicher = null;
  }
  return speicher;
}

export function listeSetzen(k: ListenKontext | null): void {
  speicher = k;
  try {
    if (k) sessionStorage.setItem(SCHLUESSEL, JSON.stringify(k));
    else sessionStorage.removeItem(SCHLUESSEL);
  } catch {
    /* Speicher voll oder gesperrt: nur im Speicher */
  }
  window.dispatchEvent(new Event(EREIGNIS));
}

export function fokusSetzen(id: string): void {
  const k = listeLesen();
  if (k && k.fokus !== id) listeSetzen({ ...k, fokus: id });
}

export interface Nachbarn {
  kontext: ListenKontext;
  index: number;
  gesamt: number;
  vorher: string | null;
  nachher: string | null;
}

export function nachbarn(leadId: string): Nachbarn | null {
  const k = listeLesen();
  if (!k) return null;
  const index = k.ids.indexOf(leadId);
  if (index < 0) return null;
  return {
    kontext: k,
    index,
    gesamt: k.ids.length,
    vorher: index > 0 ? k.ids[index - 1] : null,
    nachher: index < k.ids.length - 1 ? k.ids[index + 1] : null,
  };
}

/** Nachbarn des Leads in der gemerkten Liste, aktualisiert sich bei Änderungen. */
export function useNachbarn(leadId: string | undefined): Nachbarn | null {
  const [, setZaehler] = useState(0);
  useEffect(() => {
    const neu = () => setZaehler((z) => z + 1);
    window.addEventListener(EREIGNIS, neu);
    return () => window.removeEventListener(EREIGNIS, neu);
  }, []);
  return leadId ? nachbarn(leadId) : null;
}
